// 组件对象，大写
import autoComplete from './autoComplete.vue'
export default autoComplete
